<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content class="dialog-content">
  <div>
    <form [formGroup]="formSearch" autocomplete="off" class="form-container">
      <div>   <mat-form-field class="form-field">
        <mat-label>Search by County or ZIP</mat-label>
        <input matInput autocomplete="off"
               id="searchPhrase"
               name="searchPhrase"
               formControlName="searchPhrase"
               (keypress)="onKeyPress($event)"
               (keyup)="searchZipCodeListByPhrase($event.target.value)"
               placeholder="Search by County or ZIP">
               <mat-error *ngIf="formSearch.get('searchPhrase').invalid && formSearch.get('searchPhrase').touched">
                Only alphanumeric characters and spaces are allowed.
              </mat-error>
      </mat-form-field></div>
      
    </form>
  </div>

  <div *ngIf="waitForListingToShow">
    <mat-progress-bar value="40" mode="indeterminate"></mat-progress-bar>
    <p>Loading ZIP Codes...</p>
  </div>

  <div class="table-container">
    <div>
      <div *ngIf="noSearchResults; else displayListing">
        <p>No search results</p>
      </div>
    </div>

    <ng-template #displayListing>
      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSourceTable" style="width: 100%; table-layout: fixed;" matSort>
          
          <!-- Select Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;">
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" style="width: 20%;">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"  (keydown)="onCheckboxKeyDown($event)">
              </mat-checkbox>
            </td>
          </ng-container>
        
          <!-- ZipCode Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;">ZipCode</th>
            <td mat-cell *matCellDef="let element" style="width: 20%;">{{element.name}}</td>
          </ng-container>
        
          <!-- City Column -->
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 40%;">City</th>
            <td mat-cell *matCellDef="let element" style="width: 40%;">{{element.city}}</td>
          </ng-container>
        
          <!-- County Column -->
          <ng-container matColumnDef="county">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 40%;">County</th>
            <td mat-cell *matCellDef="let element" style="width: 40%;">{{element.county}}</td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        
      </div>
    </ng-template>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer">
  <button mat-button id="dialogZipCodeCancelButton" style="margin-right: 6px;" (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-stroked-button color="primary" id="dialogZipCodeSaveButton" type="submit" (click)="onClickSave()" [disabled]="removeButtonDisabled">
    REMOVE
  </button>
</div>

<style>
  .dialog-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .form-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .form-field {
    flex: 1 1 290px;
  }

  .table-container {
    flex: 1;
    overflow: auto;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    border-top: 1px solid #e0e0e0;
  }
</style>
